import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginateQuery, PaginatorModel } from 'symbols';
import { TYPE_SEARCH } from '../../symbols';
import {
  CategoryExpectBackendModel,
  CategoryOfTransactionModel,
  CategoryStatisticsModel,
  CurrencyPriceModel,
  FinanceScoreExpectBackendModel,
  FinanceScoreModel,
  TransactionExpectBackendModel,
  TransactionFilterModel,
  TransactionModel
} from '../symbols';

@Injectable()
export class FinanceRegisterService {
  readonly apiUrl = '/api/finance-register';

  constructor(private http: HttpClient) {
  }

  getCurrencies(): Observable<CurrencyPriceModel[]> {
    return this.http.get<CurrencyPriceModel[]>(`${this.apiUrl}/currency-price/`);
  }

  getFinanceScopes(): Observable<FinanceScoreModel[]> {
    return this.http.get<FinanceScoreModel[]>(`${this.apiUrl}/scopes/`);
  }

  getCategories(date: string): Observable<CategoryOfTransactionModel[]> {
    const params: { [key: string]: any } = {};

    if (date) {
      params['date'] = date;
    }
    return this.http.get<CategoryOfTransactionModel[]>(`${this.apiUrl}/categories/`, { params });
  }


  getTransactionList(filter?: PaginateQuery<TransactionFilterModel>): Observable<PaginatorModel<TransactionModel>> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 50,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      typeSearch: TYPE_SEARCH.BY_METADATA,
      filter: filter?.filter
    };

    if (filter?.filter?.categoryIds) {
      params['filter.categoryIds'] = filter?.filter?.categoryIds;
    }
    if (filter?.filter?.scopeIds) {
      params['filter.scopeIds'] = filter?.filter?.scopeIds;
    }

    if (filter?.filter?.searchText) {
      params['search'] = filter?.filter?.searchText || '';
    }

    if (filter?.filter?.date) {
      params['filter.date'] = filter?.filter?.date || '';
    }
    return this.http.get<PaginatorModel<TransactionModel>>(`${this.apiUrl}/transactions`, { params });
  }


  getTransactionListLazy(url: string): Observable<PaginatorModel<TransactionModel>> {
    return this.http.get<PaginatorModel<TransactionModel>>(url);
  }

  reorderScores(data: { scoreId: string; position: number }[]): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/reorder-scores`, data);
  }

  createTransaction(transactionData: TransactionExpectBackendModel): Observable<TransactionModel> {
    return this.http.post<TransactionModel>(`${this.apiUrl}/transaction`, transactionData);
  }

  updateTransaction(transactionData: TransactionExpectBackendModel, id: string): Observable<TransactionModel> {
    return this.http.patch<TransactionModel>(`${this.apiUrl}/transaction/${id}`, transactionData);
  }

  getCategoryStatistics(date: string): Observable<CategoryStatisticsModel> {
    const params: { [key: string]: any } = {};
    if (date) {
      params['date'] = date;
    }
    return this.http.get<CategoryStatisticsModel>(`${this.apiUrl}/statistics/`, { params });
  }

  deleteTransaction(transactionId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/transaction/${transactionId}`);
  }


  createTransferTransaction(transactionData: TransactionExpectBackendModel): Observable<TransactionModel> {
    return this.http.post<TransactionModel>(`${this.apiUrl}/transfer`, transactionData);
  }

  deleteScore(scoreId: string, toScoreId: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/delete-score/`, { scoreId, toScoreId });
  }

  crateScore(score: FinanceScoreExpectBackendModel): Observable<FinanceScoreModel> {
    return this.http.post<FinanceScoreModel>(`${this.apiUrl}/score`, score);
  }

  updateScore(score: FinanceScoreExpectBackendModel, scoreId: string): Observable<FinanceScoreModel> {
    return this.http.patch<FinanceScoreModel>(`${this.apiUrl}/score/${scoreId}`, score);
  }

  createCategory(category: CategoryExpectBackendModel): Observable<CategoryOfTransactionModel> {
    return this.http.post<CategoryOfTransactionModel>(`${this.apiUrl}/category`, category);
  }


  updateCategory(category: CategoryExpectBackendModel, categoryId: string): Observable<CategoryOfTransactionModel> {
    return this.http.patch<CategoryOfTransactionModel>(`${this.apiUrl}/category/${categoryId}`, category);
  }


  deleteCategory(categoryId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/category/${categoryId}`);
  }
}
